module.exports = __webpack_public_path__ + "static/carousel-image-2-e7bca42371b79480722ca114f7dd242f.jpg";